import { useCallback, useEffect } from 'react';

import { MixpanelEvent } from './types';
import mixpanel from '../../../webapp/src/providersV2/mixpanel';
import { useAppContext } from '../../../webapp/src/Providers/AppProvider/AppContext';

export const useMixpanel = () => {
  const { user: currUser } = useAppContext();

  const env =
    process.env.NODE_ENV === 'development' ? 'development' : 'production';

  const track = useCallback((event: MixpanelEvent) => {
    mixpanel.track(event?.name, {
      ...event?.props,
      email: currUser.Email,
      env
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const identify = useCallback(
    (user: { id: string; email: string; name: string }) => {
      mixpanel.identify(user.id);
      mixpanel.people.set({
        $email: user.email,
        $name: user.name,
        env
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (currUser) {
      identify({
        id: currUser.ID?.toString(), // Ensure ID is a string
        email: currUser.Email,
        name: currUser.FullName
      }); // Safe and typed
      track({ name: 'User Identified', props: { email: currUser.Email } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currUser]);

  return { track, identify };
};
